export const projects = [
  {
    id: 1,
    year: "2025",
    month: "Mar - Nov",
    title: "AIETA AI Interviewer",
    description: "AI-powered platform that generates interview questions and evaluates spoken answers using LLMs.",
    techStack: ["FastAPI", "React", "Groq"],
    github: "https://github.com/pratham4544/AI_Interviewer_App",
    live: null,
    rune: "🎙️",
    color: "from-purple-600 to-cyan-600",
    accentColor: "#8B5CF6"
  },
  {
    id: 2,
    year: "2024",
    month: "Aug - Dec",
    title: "RAG Evaluator",
    description: "Measures retrieval-augmented generation pipeline quality using standard evaluation metrics.",
    techStack: ["Streamlit", "LangChain", "RAGAS"],
    github: "https://github.com/pratham4544/RAG-Evaluator",
    live: "https://rag-evaluator.streamlit.app",
    rune: "📊",
    color: "from-blue-600 to-purple-600",
    accentColor: "#3B82F6"
  },
  {
    id: 3,
    year: "2024",
    month: "Jun - Aug",
    title: "Financial Forecasting Agent",
    description: "Analyzes market data to surface patterns and generate forecasts for financial screening tasks.",
    techStack: ["Python", "OpenAI", "LangChain"],
    github: "https://github.com/pratham4544/Financial-Forecasting-Agent-Screener",
    live: null,
    rune: "💰",
    color: "from-green-600 to-emerald-600",
    accentColor: "#10B981"
  },
  {
    id: 4,
    year: "2024",
    month: "Mar - May",
    title: "Smart Medical Summarizer",
    description: "Summarizes lengthy medical documents into concise, digestible notes using multiple LLM backends.",
    techStack: ["Streamlit", "Cohere", "LangChain"],
    github: "https://github.com/pratham4544/smart_summarizer_multi_llm",
    live: null,
    rune: "🏥",
    color: "from-red-600 to-orange-600",
    accentColor: "#EF4444"
  },
  {
    id: 5,
    year: "2023",
    month: "Oct - Dec",
    title: "Chat with Bhagavad Gita",
    description: "Retrieval-augmented chatbot for asking questions about the Bhagavad Gita with grounded answers.",
    techStack: ["Streamlit", "LangChain", "FAISS"],
    github: "https://github.com/pratham4544/chat-with-gita",
    live: null,
    rune: "📿",
    color: "from-yellow-600 to-amber-600",
    accentColor: "#F59E0B"
  },
  {
    id: 6,
    year: "2023",
    month: "Aug - Oct",
    title: "Chat with Freedom Fighters",
    description: "RAG-based chatbot letting users ask questions about India's freedom fighters and their history.",
    techStack: ["Streamlit", "RAG", "NLP"],
    github: "https://github.com/pratham4544/chat-with-freedom-fighters",
    live: null,
    rune: "🇮🇳",
    color: "from-orange-600 to-red-600",
    accentColor: "#F97316"
  },
  {
    id: 7,
    year: "2023",
    month: "Mar - Aug",
    title: "Role-Based ChatBot",
    description: "Chatbot that adapts its responses and access based on the user's role within an organization.",
    techStack: ["Streamlit", "FastAPI", "Google AI"],
    github: "https://github.com/pratham4544/ds-rpc-01",
    live: "https://role-base-chatbot-codebasics.streamlit.app",
    rune: "💼",
    color: "from-indigo-600 to-purple-600",
    accentColor: "#6366F1"
  },
  {
    id: 8,
    year: "2023",
    month: "Jan - Mar",
    title: "BOM Loan Chatbot",
    description: "Chatbot that helps users navigate loan requirements and financial assistance queries quickly.",
    techStack: ["Python", "NLP", "Chatbot"],
    github: "https://github.com/pratham4544/BOM_Loan_Chatbot",
    live: null,
    rune: "🏦",
    color: "from-teal-600 to-cyan-600",
    accentColor: "#14B8A6"
  },
  {
    id: 9,
    year: "2025",
    month: "Ongoing",
    title: "Jellyfin Media Server",
    description: "Self-hosted media server running on home infrastructure, exposed securely via a reverse proxy.",
    techStack: ["Docker", "Nginx", "Jellyfin"],
    github: null,
    live: "https://jellyfin.prathameshshete.in",
    rune: "🎬",
    color: "from-purple-600 to-indigo-600",
    accentColor: "#9333EA"
  },
  {
    id: 10,
    year: "2026",
    month: "Ongoing",
    title: "Vaishali — AI Hiring Platform",
    description: "AI-powered hiring platform that screens resumes, conducts interviews, and shortlists candidates.",
    techStack: ["React", "FastAPI", "Python"],
    github: null,
    live: "https://screener.prathameshshete.in",
    rune: "🧑‍💼",
    color: "from-pink-600 to-rose-600",
    accentColor: "#EC4899"
  },
  {
    id: 11,
    year: "2026",
    month: "Ongoing",
    title: "Interview Platform",
    description: "Multi-phase AI interview platform covering voice Q&A, system design, and live coding challenges.",
    techStack: ["React", "FastAPI", "Docker"],
    github: null,
    live: "https://interview.prathameshshete.in",
    rune: "🗣️",
    color: "from-sky-600 to-blue-600",
    accentColor: "#0EA5E9"
  },
  {
    id: 12,
    year: "2026",
    month: "Ongoing",
    title: "Codex",
    description: "Multi-phase AI interview platform covering voice Q&A, system design, and coding challenges.",
    techStack: ["React", "FastAPI", "Docker"],
    github: null,
    live: "https://codex.prathameshshete.in",
    rune: "💻",
    color: "from-lime-600 to-green-600",
    accentColor: "#84CC16"
  },
  {
    id: 13,
    year: "2022",
    month: "Archive",
    title: "Data Researcher Tools For Colleges",
    description: "Uses Google's Generative AI to extract structured highlights, cutoffs, placements, and results.",
    techStack: ["Python", "Google AI", "Streamlit"],
    github: null,
    live: "https://data-researcher-for-colleges.streamlit.app/",
    rune: "🎓",
    color: "from-blue-600 to-indigo-600",
    accentColor: "#2563EB"
  },
  {
    id: 14,
    year: "2022",
    month: "Archive",
    title: "Website Custom ChatBot",
    description: "Virtual assistant that scrapes a website automatically and answers visitor questions about it.",
    techStack: ["Python", "Hugging Face", "Web Scraping"],
    github: null,
    live: "https://huggingface.co/spaces/edjdhug3/chatbot_3",
    rune: "💬",
    color: "from-violet-600 to-purple-600",
    accentColor: "#7C3AED"
  },
  {
    id: 15,
    year: "2022",
    month: "Archive",
    title: "HTML Transformer",
    description: "Web app that speeds up converting and uploading articles, cutting publishing time dramatically.",
    techStack: ["Python", "Streamlit", "Automation"],
    github: null,
    live: "https://html-transformer.streamlit.app/",
    rune: "📄",
    color: "from-emerald-600 to-teal-600",
    accentColor: "#059669"
  },
  {
    id: 16,
    year: "2022",
    month: "Archive",
    title: "IPL Match Winning Prediction",
    description: "Classification model predicting IPL match win probability using historical match data trends.",
    techStack: ["Python", "Scikit-learn", "Streamlit"],
    github: "https://github.com/pratham4544/ipl-match-win-predicition",
    live: null,
    rune: "🏏",
    color: "from-red-600 to-rose-600",
    accentColor: "#DC2626"
  },
  {
    id: 17,
    year: "2022",
    month: "Archive",
    title: "Flipkart Reviews Scrapper",
    description: "Scraper that pulls 2–4 star Flipkart product reviews to help gauge genuine product quality.",
    techStack: ["Python", "Flask", "Web Scraping"],
    github: "https://github.com/pratham4544/flipkart_review",
    live: null,
    rune: "🛒",
    color: "from-orange-600 to-amber-600",
    accentColor: "#EA580C"
  },
  {
    id: 18,
    year: "2022",
    month: "Archive",
    title: "Netflix Movies Dashboard",
    description: "Interactive Tableau dashboard exploring a Kaggle Netflix dataset — movies, ratings, and genres.",
    techStack: ["Tableau", "Kaggle", "Data Viz"],
    github: null,
    live: "https://www.mavenanalytics.io/project/1219",
    rune: "📺",
    color: "from-rose-600 to-red-600",
    accentColor: "#E11D48"
  },
  {
    id: 19,
    year: "2022",
    month: "Archive",
    title: "IPL Match Power BI Dashboard",
    description: "Interactive Power BI dashboard analyzing IPL match data — top players and team performance.",
    techStack: ["Power BI", "Python", "Excel"],
    github: null,
    live: "https://www.mavenanalytics.io/project/1492",
    rune: "🏆",
    color: "from-yellow-600 to-orange-600",
    accentColor: "#CA8A04"
  },
  {
    id: 20,
    year: "2026",
    month: "Ongoing",
    title: "Typing Practice — GCCTBC Exam Demo",
    description: "Typing speed and accuracy practice tool built as a demo for the GCCTBC exam.",
    techStack: ["React", "JavaScript"],
    github: null,
    live: "https://typing.prathameshshete.in",
    rune: "⌨️",
    color: "from-cyan-600 to-blue-600",
    accentColor: "#0891B2"
  }
];
